module.exports = __webpack_public_path__ + "static/media/death.535ee373.svg";